import { createAction } from '../../utils/redux/createAction';
import { SURVEYS_TYPES } from './constants';

export const surveyActions = {
  linkConsent: createAction(SURVEYS_TYPES.LINK_CONSENT),
};



// WEBPACK FOOTER //
// ./src/redux/surveys/actions.js